module.exports = __webpack_public_path__ + "img/fast-register-bg.f24e5e8a.png";